import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { schema } from './EmailChangeViaSupportPopup.schema';
import { EmailChangeViaSupportPopupProps } from './EmailChangeViaSupportPopup.types';

export const useEmailChangeViaSupportPopup = (props: EmailChangeViaSupportPopupProps) => {
    const { onNext } = props;

    const form = useForm<z.infer<typeof schema>>({
        defaultValues: {
            email: '',
        },
        resolver: zodResolver(schema),
    });

    const formSubmit = form.handleSubmit((_data) => {
        // TODO: Will be implemented in a separate task

        onNext();
    });

    return {
        form,
        formSubmit,
    };
};
